import { render, staticRenderFns } from "./Effecitve.vue?vue&type=template&id=61b94040"
import script from "./Effecitve.vue?vue&type=script&lang=js"
export * from "./Effecitve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports